import type {AppBreadcrumbsProps} from "../Breadcrumbs.types";

export const isLast = (index: number, breadcrumbs: AppBreadcrumbsProps["items"]) => {
  return breadcrumbs.length - 1 === index;
};
